import useFormacionesList from "./useFormacionesList";
import useFormacionForm from "./useFormacionForm";
import useFormacionesOptions from "./useFormacionesOptions";

export default function useFormacionesLogic() {
  const options = useFormacionesOptions();
  const list = useFormacionesList();

  const form = useFormacionForm({
    onCreated: () => list.reload(),
    onUpdated: (updated) => {
      list.upsertFormacion(updated);
      if (list.seleccionado?.id === updated.id) list.setSeleccionado(updated);
      list.reload(); // asegura datos consistentes desde el backend
    },
    onDeleted: (deleted) => {
      list.removeFormacion(deleted.id);
      if (list.seleccionado?.id === deleted.id) list.setSeleccionado(null);
      list.reload();
    },
  });

  return {
    ...list,
    ...options,
    form,
  };
}
